import { RegistroVacinacaoInput } from 'graphql/types.generated'

import { RegistroVacinacaoFormModel } from '../model'

export const convertRegistroVacinacaoToInput = (formModel: RegistroVacinacaoFormModel[]): RegistroVacinacaoInput[] =>
  formModel?.map((form) => ({
    id: form.id,
    vacinacao: form.vacinacao,
    tipoRegistroVacinacao: form.tipoRegistroVacinacao.toString(),
    isRegistroAnterior: form.isRegistroAnterior,
    imunobiologico: form.imunobiologico,
    estrategiaVacinacao: form.estrategiaVacinacao?.id,
    doseImunobiologico: form.doseImunobiologico,
    dataAprazamento: form.dataAprazamento,
    dataAplicacao: form.dataAplicacao,
    loteImunobiologico: form.loteImunobiologico?.id,
    viaAdministracao: form.viaAdministracao.id,
    localAplicacaoVacinacao: form.localAplicacaoVacinacao.id,
    observacoes: form.observacoes,
  }))
